if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

if (!window.quickAddCardFormSubmitHandlerAttached) {
  window.quickAddCardFormSubmitHandlerAttached = true;

  document.addEventListener('click', (event) => {
    const submitButton = event.target.closest('.card__quick-add-submit');
    if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();

    const loadingSpinner = submitButton.querySelector('.loading__spinner');
    const soldOutMessage = submitButton.querySelector('.sold-out-message');
    const submitButtonText = submitButton.querySelector('span:not(.sold-out-message)');
    const variantId = submitButton.dataset.variantId;

    if (!variantId) return;

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    loadingSpinner?.classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    const cartNotification = document.querySelector('cart-notification');
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartNotification || cartDrawer) {
      const cartComponent = cartNotification || cartDrawer;
      formData.append(
        'sections',
        cartComponent.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cartComponent.setActiveElement(document.activeElement);
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          submitButton.setAttribute('disabled', 'disabled');
          submitButtonText?.classList.add('hidden');
          soldOutMessage?.classList.remove('hidden');
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'quick-add',
          cartData: response,
          productVariantId: variantId,
        });

        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
        }

        if (cartNotification) {
          cartNotification.setActiveElement(document.activeElement);
          cartNotification.renderContents(response);
        } else if (cartDrawer) {
          cartDrawer.setActiveElement(document.activeElement);
          cartDrawer.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        if (submitButton.getAttribute('disabled') !== 'disabled') {
          submitButton.removeAttribute('aria-disabled');
        }
        loadingSpinner?.classList.add('hidden');
      });
  });
}

if (!window.cardMediaQuickAddNavigationAttached) {
  window.cardMediaQuickAddNavigationAttached = true;

  document.addEventListener('click', (event) => {
    const media = event.target.closest('.card__media');
    if (!media) return;

    if (event.target.closest('.card__quick-add, .quick-add__submit, button, input, select, textarea, label, a')) {
      return;
    }

    const mediaLink = media.querySelector('.card__media-link');
    if (!mediaLink || !mediaLink.href) return;

    window.location.href = mediaLink.href;
  });
}